/*=========================================================================================
  File Name: centre_hospitalierGetters.js
  Description: Centre Hospitalier Module Getters
  ----------------------------------------------------------------------------------------
==========================================================================================*/


export default {}
